import { render, staticRenderFns } from "./videoAndText.vue?vue&type=template&id=773f1fec&scoped=true&"
import script from "./videoAndText.vue?vue&type=script&lang=js&"
export * from "./videoAndText.vue?vue&type=script&lang=js&"
import style0 from "./videoAndText.vue?vue&type=style&index=0&id=773f1fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f1fec",
  null
  
)

export default component.exports